import AdminLayout from '../../components/feature/AdminLayout';
import DemoTenantsTable from './components/DemoTenantsTable';

export default function DemoTenantsPage() {
  return (
    <AdminLayout>
      <DemoTenantsTable mode="active" />
    </AdminLayout>
  );
}
